import Model, { hasMany } from '@ember-data/model';
import CampaignModel from './campaign';
import HostCampaignModel from './host-campaign';
import CampaignGoalModel from './campaign-goal';

export default class FundCampaignsInfoModel extends Model {
  @hasMany('campaign', { async: false, inverse: null }) campaigns!: CampaignModel[];
  @hasMany('host-campaign', { async: false, inverse: null })
  hostCampaigns!: HostCampaignModel[];
  @hasMany('campaign-goal', { async: false, inverse: null })
  activeCampaignGoals!: CampaignGoalModel[];
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'fund-campaigns-info': FundCampaignsInfoModel;
  }
}
